import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { BillState } from '../types';

interface BillStatusBadgeProps {
  state: BillState;
  className?: string;
}

const stateColors: Record<BillState, string> = {
  DRAFT: 'bg-yellow-500 hover:bg-yellow-500',
  ARCHIVED: 'bg-black hover:bg-black',
  PENDING: 'bg-green-400 hover:bg-green-400',
  UNPAID: 'bg-red-500 hover:bg-red-500',
  PAID: 'bg-emerald-600 hover:bg-emerald-600',
};

export function BillStatusBadge({ state, className }: BillStatusBadgeProps) {
  const { t } = useTranslation();

  return (
    <Badge
      className={cn(
        'rounded-full text-white',
        stateColors[state] || 'bg-gray-400',
        className
      )}
    >
      {t(state.toLowerCase())}
    </Badge>
  );
}
